export default __webpack_public_path__ + "static/media/more_about_u.bd1c63b7.png";